import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { Step } from './Step';
import { Data } from '../signup-data/DATA';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { UseCase } from 'signup-constants/signupData/UseCaseOption';
import { useSignupData } from '../signup-data/useSignupData';
import { useView } from './useView';
import { ProblemAwareness } from '../signup-data/ConsiderationProfileOptions';
import SkipStep from '../views-components/SkipStep';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSelector } from 'react-redux';
import { isInACQ142VariantAMSS } from '../experiments/gswhV1/gswhUtils';
export const UseCaseIllustrations = new Map([[UseCase.CreateContent, 'pencil'], [UseCase.TrackContacts, 'leads'], [UseCase.CloseDeals, 'sales-free'], [UseCase.ConvertCustomers, 'target']]);

const UseCaseView = () => {
  const {
    data: problemAwareness
  } = useSignupData(Data.ProblemAwareness);
  const {
    submit
  } = useView({
    stepKey: Step.UseCase
  });
  const {
    setData,
    setDataCompleted
  } = useSignupData(Data.UseCase);
  const options = DataOptions[Data.UseCase];

  const handleOtherClick = () => {
    setData(UseCase.Other);
    setDataCompleted();
    submit();
  };

  const isACQ142VariantAMSS = useSelector(isInACQ142VariantAMSS);
  const shouldShowOtherLink = problemAwareness === ProblemAwareness.no;

  const getSubtitle = () => {
    const subtitleMessage = `views.USE_CASE.subtitle${isACQ142VariantAMSS && '_mss'}`;
    const message = isValidI18nKey(subtitleMessage) ? subtitleMessage : `views.USE_CASE.subtitle`;
    return message;
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BaseButtonsView, {
      columnCount: isACQ142VariantAMSS ? 1 : 4,
      helperTextString: getSubtitle(),
      nextButtonLabel: "button.getStarted",
      optionHeight: "70px",
      options: options,
      shouldDisableAutofocus: true,
      shouldShowIllustrations: !isACQ142VariantAMSS
    }), shouldShowOtherLink && /*#__PURE__*/_jsx(SkipStep, {
      handleSkip: handleOtherClick,
      stepKey: Step.UseCase
    })]
  });
};

export default UseCaseView;